<template>
    <div class="questions-component">
        <card header-classes="bg-transparent py-0" body-classes="bg-transparent p-0">
            <div slot="header" class="row align-items-center">
                <div class="col-lg-6">
                    <h6 class="text-uppercase ls-1 mb-1">Daftar Soal</h6>
                </div>
                <div class="col-lg-6 text-lg-right">
                    <b-dropdown id="dropdown-1" right text="AKSI" size="sm" class="m-md-2">
                        <b-dropdown-item @click="showQuestionFormModal()"><i class="fa fa-plus" aria-hidden="true"></i>Tambah Soal</b-dropdown-item>
                        <b-dropdown-item @click="showImportFormModal()"><i class="fa fa-upload" aria-hidden="true"></i>Import Soal</b-dropdown-item>
                        <b-dropdown-item @click="downloadTemplateSoal()"><i class="fa fa-download" aria-hidden="true"></i>Download Template Soal</b-dropdown-item>
                    </b-dropdown>   
                    <div>
                    </div>
                </div>
            </div>
            <div v-if="true" class="text-center text-muted">
                <div id="question-list" class="p-4">
                    <v-client-table ref="question_ref" :data="overview" :columns="columns" :options="options">
                        <div slot="nomor" slot-scope="{ index }">
                            <div class="my-2">
                                <p>{{index}}</p>
                            </div>
                        </div>
                        <div slot="question" slot-scope="props">
                            <div class="my-2">
                                <img v-if="props.row.file_path"
                                    class="img-left"
                                    width="100"
                                    :src="props.row.file_path"
                                    alt="Logo"
                                />
                                <p v-html="props.row.question"></p>
                                <div v-for="(option, index) in props.row.options" :key="index">
                                    <div style="padding-bottom:7px">
                                        <input
                                            type="radio"
                                            :name="'radio-group-'+props.row.id"
                                            v-bind:value="option"
                                            :checked="option.is_answer == '1'"
                                        >
                                        <label v-html="option.choice"></label>
                                        <br>
                                        <img v-if="option.file_path"
                                            class="sticky-img"
                                            width="100"
                                            :src="option.file_path"
                                            alt="Logo"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div slot="aksi" slot-scope="props">
                            <div class="my-2">
                                <a href="javascript:void(0)" class="icon-clicked p-1" @click="showQuestionFormModal(props.row)"><i class="fa fa-edit" aria-hidden="true"></i></a>
                                <a href="javascript:void(0)" class="icon-clicked p-1" @click="confirmDeleteQuestion(props.row.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                            </div>
                        </div>
                    </v-client-table>
                </div>
            </div>
            <div v-else class="p-2 text-center text-muted">
                Saat ini belum ada soal
            </div>
        </card>
		<b-modal
			ref="question-form-modal"
			class="question-form-modal"
			size="lg"
            :title="titleSoal"
            @show="resetQuestionForm"
            @hidden="resetQuestionForm"
			hide-footer
			no-close-on-backdrop
		>
            <question-form
                :quizId="quizId"
                :questionId="questionId"
                :questionDetail="questionDetail"
            ></question-form>
		</b-modal>
		<b-modal
			ref="question-import-form-modal"
			class="question-import-form-modal"
			size="md"
            title="Import Soal"
            @show="resetImportForm"
            @hidden="resetImportForm"
			hide-footer
			no-close-on-backdrop
		>
            <b-form data-vv-scope="question-import-form">
                <b-form-group
                    label="Soal"
                    label-for="soal"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-file
                        ref="file_path"
                        name="file_path"
                        data-vv-as="File soal"
                        v-model="import_form.file_soal"
                        :state="Boolean(import_form.file_soal)"
                        type="file"
                        placeholder="Pilih file disini. . ."
                        drop-placeholder="Drop file here..."
                        v-validate="'required'"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    >
                    </b-form-file>
                    <span :class="{ 'error-validation': errors.first('question-import-form.file_path') }">{{ errors.first('question-import-form.file_path') }}</span>
                </b-form-group>
            </b-form>
            <hr class="m-0">
            <div class="form-footer d-flex justify-content-end mt-3">
                <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
                <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideImportFormModal">BATAL</b-button>
                <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveImportSoal">SIMPAN</b-button>
            </div>
		</b-modal>
    </div>
</template> 
<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
    import axios from '../../../axiosHelper';	import QuestionForm from "./QuestionForm";
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        props: {
            quizId: {
                type: String,
                default: null
            },
        },
        components: {
            QuestionForm,
            SquareLoader
        },
		data() {
			return {
                showLoader: false,
                columns: ['nomor', 'question', 'aksi'],
                questionId: null,
                questionDetail: {},
                import_form: {
                    file_soal: null
                },
                titleSoal: null,
                options: {
                    headings: {
                        nomor: 'No.',
                        question: 'Butir Soal',
                        aksi: 'Aksi'
                    },
                    sortable: ['question'],
                    filterable: ['question'],
                    initialPage: 1,
                    perPage: 5,
                    perPageValues: [5, 10, 15],
                    pagination: {
                        chunk:3,
                        nav: 'relative',
                        edge: true,
                        show: true
                    },
                    rowAttributesCallback() {
                        return {
                            "style": "text-align: left;"
                        }
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                questionOverview: 'getQuestionOverview',
                overview: 'getListSoal',
                token: 'getToken'
            })
        },
        watch: {
        },
        methods: {
            showQuestionFormModal(param) {
                // if (this.questionOverview.is_publish == '1') {
				// 	this.$swal.fire('Perhatian!', 'Perubahan hanya bisa dilakukan jika penilaian belum DITERBITKAN!', 'warning')
                // } else {
                    if (param) {
                        this.questionId = param.id
                        this.questionDetail = param
                        this.titleSoal = "Edit Soal"
                    } else {
                        this.questionDetail = {}
                        this.questionId = null
                        this.titleSoal = "Tambah Soal"
                    }
                    this.$refs['question-form-modal'].show()
                // }
            },
            hideQuestionFormModal() {
                this.$refs['question-form-modal'].hide()
                this.resetQuestionForm()
            },
            resetQuestionForm() {
                EventBus.$emit('resetQuestionForm', true)
            },
            resetImportForm() {
                this.import_form.file_soal = null
                this.$validator.reset()
            },
            showImportFormModal() {
                // if (this.questionOverview.is_publish == '1') {
				// 	this.$swal.fire('Perhatian!', 'Perubahan hanya bisa dilakukan jika penilaian belum DITERBITKAN!', 'warning')
                // } else {
                    this.$refs['question-import-form-modal'].show()
                // }
            },
            hideImportFormModal() {
                this.$refs['question-import-form-modal'].hide()
                this.resetImportForm()
            },
            downloadTemplateSoal() {
                let token = this.token
                let route = axios.defaults.baseURL+'/v1/quiz/question/download-template-question?token='+token
                window.open(route);
            },
			async getQuestionOverview(quizId) {
				await this.$store.dispatch('getQuestionOverview', { quizId })
					.then(() => {
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
			async confirmDeleteQuestion(questionId) {
                // if (this.questionOverview.is_publish == '1') {
				// 	this.$swal.fire('Perhatian!', 'Perubahan hanya bisa dilakukan jika penilaian belum DITERBITKAN!', 'warning')
                // } else {
                    this.$swal.fire({
                        title: 'Apakah anda yakin?',
                        text: '',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Ya, saya yakin',
                        cancelButtonText: 'Tidak'
                    }).then((result) => {
                        if (result.value) {
                            this.deleteQuestion(questionId)
                        }
                    })
                // }
			},
            async deleteQuestion(id) {
                // if (this.questionOverview.is_publish == '1') {
				// 	this.$swal.fire('Perhatian!', 'Perubahan hanya bisa dilakukan jika penilaian belum DITERBITKAN!', 'warning')
                // } else {
                    await this.$store.dispatch('deleteQuestion', { id })
                        .then((res) => {
                            this.getQuestionOverview(this.quizId)
                            this.$swal.fire('Success', res.message, 'success')
                        })
                        .catch((err)=> {
                            this.$swal.fire('Failed', err.response.data.message, 'error')
                        })
                // }
            },
            async saveImportSoal() {
                // if (this.questionOverview.is_publish == '1') {
				// 	this.$swal.fire('Perhatian!', 'Perubahan hanya bisa dilakukan jika penilaian belum DITERBITKAN!', 'warning')
                // } else {
                    let scope = 'question-import-form'
                    this.$validator.validateAll(scope).then(valid => {
                        if (valid) {
                            this.showLoader = true
                            let formData = new FormData()
                            formData.append('file', this.import_form.file_soal)
                            formData.append('quiz_id', this.quizId)
                            this.$store.dispatch('importQuestion', formData)
                                .then((res) => {
                                    this.showLoader = false
                                    this.$swal.fire('Success', res.data.message, 'success')
                                    this.getQuestionOverview(this.quizId)
                                })
                                .catch((err)=> {
                                    let error = err.response
                                    this.showLoader = false
                                    if (error.status == 400) {
                                        this.errorValidate(error.data, scope)
                                    } else {
                                    this.$swal.fire('Failed', error.data.message, 'error')
                                    }
                                })
                        }
                    })
                // }
            }
        },
        created() {
            this.getQuestionOverview(this.quizId)
			EventBus.$on('hideQuestionFormModal', (val) => {
				if (val) {
					this.hideQuestionFormModal()
				}
			})
        }
    }
</script>

<style lang="css" scoped>
.btn-custom-primary {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
}
.table-responsive {
    margin-bottom: 0;
}
.btn-custom-primary:hover, .btn-custom-primary:not(:disabled):not(.disabled):active, .btn-custom-primary:focus {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
.table-striped {
    background-color: rgba(0, 0, 0, 0) !important;
}
[type="radio"]:checked,
[type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
}
[type="radio"]:checked + label,
[type="radio"]:not(:checked) + label
{
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: #666;
}
[type="radio"]:checked + label:before,
[type="radio"]:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 1px solid #ddd;
    border-radius: 100%;
    background: #fff;
}
[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
    content: '';
    width: 12px;
    height: 12px;
    background: #ab3233;
    position: absolute;
    top: 3px;
    left: 3px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
}
[type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
}
[type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
}
</style>
<style scoped>
::v-deep .VueTables__search-field label {
    display: none !important;
}
::v-deep .VuePagination__count {
    display: none;
}
::v-deep .VueTables__row {
    background-color: white !important;
    --bs-table-accent-bg: unset !important;
}
::v-deep .VueTables__table thead tr th:last-child {
    width: 20px;
}
::v-deep .VueTables__table thead tr th:first-child {
    width: 10px;
}
::v-deep .VueTables__table thead tr th {
    background-color: #ca062a;
    color: white;
    border-color: #ca062a;
}
::v-deep .VuePagination nav {
    display: flex!important;
    -webkit-box-pack: end!important;
    -ms-flex-pack: end!important;
    justify-content: flex-end!important;
}
::v-deep .VuePagination, ::v-deep .VuePagination nav {
    padding: 0 !important;
    margin: 0 !important;
}
</style>